import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { Capacitor } from '@capacitor/core';

// Different haptic patterns for different actions
export const HapticPatterns = {
  LIGHT: ImpactStyle.Light,
  MEDIUM: ImpactStyle.Medium,
  HEAVY: ImpactStyle.Heavy,
  SUCCESS: NotificationType.Success,
  ERROR: NotificationType.Error,
  WARNING: NotificationType.Warning
};

export const vibrate = async (pattern: ImpactStyle | NotificationType) => {
  if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {
    if (pattern === NotificationType.Success || pattern === NotificationType.Error || pattern === NotificationType.Warning) {
      await Haptics.notification({ type: pattern });
    } else {
      await Haptics.impact({ style: pattern });
    }
  } else if (typeof navigator !== 'undefined' && navigator.vibrate) {
    // Fallback for web
    const duration = pattern === ImpactStyle.Light ? 10 :
                    pattern === ImpactStyle.Medium ? 20 :
                    pattern === ImpactStyle.Heavy ? 30 :
                    pattern === NotificationType.Success ? [10, 30, 10] :
                    pattern === NotificationType.Error ? [50, 30, 50] :
                    pattern === NotificationType.Warning ? [30, 20] : 20;
    navigator.vibrate(duration);
  }
};
